import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

export default function SpotlightCard({
    title,
    description,
    imgSrc,
    imgAlt,
    link,
    comingSoon,
    publishedOn,
}) {
    const Wrapper = comingSoon ? 'div' : Link;
    const wrapperProps = comingSoon
        ? { className: 'spotlight-container text-decoration-none' }
        : {
              to: link,
              className: 'spotlight-container text-decoration-none',
          };

    return (
        <Wrapper {...wrapperProps}>
            <Row className="d-none d-md-flex">
                <Col
                    md={6}
                    className="text-start d-flex flex-column justify-content-between"
                >
                    <h2 className="spotlight-item-title fs-1">{title}</h2>
                    {publishedOn && (
                        <p className="text-muted small mb-0">
                            Published on: {publishedOn}
                        </p>
                    )}
                    <p className="fs-5 spotlight-item-description">
                        {description}
                    </p>
                    {comingSoon ? (
                        <span className="px-4 py-2 fs-5 fw-semibold d-inline-flex align-items-center gap-2 align-self-start rounded-pill bg-secondary bg-opacity-25 text-dark">
                            Coming Soon
                        </span>
                    ) : (
                        <Button
                            as="span"
                            className="px-4 py-2 fs-5 fw-bold d-inline-flex align-items-center gap-2 align-self-start spotlight-read-btn"
                        >
                            Read
                            <span className="spotlight-arrow d-inline-block fs-4">
                                →
                            </span>
                        </Button>
                    )}
                </Col>

                <Col md={6} className="position-relative">
                    {comingSoon && (
                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center rounded-5 spotlight-coming-soon-overlay">
                            <span className="fs-3 fw-bold text-white bg-dark bg-opacity-75 px-4 py-2 rounded-pill">
                                Coming Soon
                            </span>
                        </div>
                    )}
                    <img
                        src={imgSrc}
                        alt={imgAlt}
                        className={`img-fluid spotlight-item-image w-100 object-fit-cover ${comingSoon ? 'opacity-50' : ''}`}
                        draggable="false"
                    />
                </Col>
            </Row>

            <div className="d-md-none text-start">
                <h2 className="spotlight-item-title fs-1 mb-3">{title}</h2>
                {publishedOn && (
                    <p className="text-muted small mb-3">
                        Published on: {publishedOn}
                    </p>
                )}
                <div className="position-relative mb-3">
                    {comingSoon && (
                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center rounded-4 spotlight-coming-soon-overlay">
                            <span className="fs-5 fw-bold text-white bg-dark bg-opacity-75 px-3 py-1 rounded-pill">
                                Coming Soon
                            </span>
                        </div>
                    )}
                    <img
                        src={imgSrc}
                        alt={imgAlt}
                        className={`img-fluid spotlight-item-image w-100 object-fit-cover ${comingSoon ? 'opacity-50' : ''}`}
                        draggable="false"
                    />
                </div>
                <p className="fs-5 spotlight-item-description mb-3">
                    {description}
                </p>
                {comingSoon ? (
                    <span className="px-3 py-1 fs-6 fw-semibold d-inline-flex align-items-center gap-2 rounded-pill bg-secondary bg-opacity-25 text-dark">
                        Coming Soon
                    </span>
                ) : (
                    <Button
                        as="span"
                        className="px-3 py-1 fs-6 fw-bold d-inline-flex align-items-center gap-2 spotlight-read-btn spotlight-read-btn-mobile"
                    >
                        Read
                        <span className="spotlight-arrow d-inline-block">
                            →
                        </span>
                    </Button>
                )}
            </div>
        </Wrapper>
    );
}
SpotlightCard.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    comingSoon: PropTypes.bool,
    publishedOn: PropTypes.string,
};
